import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ss-tamanho-completo" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-23" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Produto")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1" })
], -1)
const _hoisted_6 = { class: "ant-col ant-col-xs-22 ant-col-xl-23" }
const _hoisted_7 = { class: "ss-margin-campos" }
const _hoisted_8 = { class: "ant-col ant-col-xs-2 ant-col-xl-1 ss-alinhar-centro" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, {
              label: "Localizar produtos",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_produto, {
                  ref: "campoNovoSemelhante",
                  varios: true,
                  codigosSelecionados: _ctx.state.novosSemelhantes,
                  "onUpdate:codigosSelecionados": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.novosSemelhantes) = $event)),
                  placeholder: "Digite o código interno, código de barras, código personalizado ou descrição do produto...",
                  empresas: _ctx.props.empresas,
                  apresentarCodigoInterno: true
                }, null, 8, ["codigosSelecionados", "empresas"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_form_item, {
              label: " ",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-secondary ant-btn-block",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarSemelhante()))
                }, " Adicionar ")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_5,
        (_ctx.computedSemelhantes.length <= 0)
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "Nenhum produto foi adicionado ainda"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form, {
          name: "ss-form-produto-semelhantes",
          class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal",
          model: _ctx.computedSemelhantes
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedSemelhantes, (produtoSemelhante, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "ant-row ss-grade-personalizada-linha",
                key: index
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_selecionar_produto, {
                      codigoSelecionado: produtoSemelhante.codigoProdutoSemelhante,
                      "onUpdate:codigoSelecionado": ($event: any) => ((produtoSemelhante.codigoProdutoSemelhante) = $event),
                      empresas: _ctx.props.empresas,
                      apresentarCodigoInterno: true,
                      limparSelecao: false
                    }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "empresas"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-secondary",
                    onClick: ($event: any) => (_ctx.removerSemelhante(index))
                  }, [
                    _createVNode(_component_icone, { nome: "excluir" })
                  ], 8, _hoisted_9)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ]))
}